<div class="wrapper">
    <div class="content">
        <div>
            <h1>Laster...</h1>
            <div class="spinner"></div>
        </div>
    </div>
</div>
